"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.DependentType = exports.Source = exports.BillingProviderType = exports.PaymentMethodType = exports.Period = exports.Title = exports.Status = exports.GroupEnrollmentAction = void 0;
var GroupEnrollmentAction;
(function (GroupEnrollmentAction) {
    GroupEnrollmentAction["CREATED"] = "CREATED";
    GroupEnrollmentAction["UPDATED"] = "UPDATED";
    GroupEnrollmentAction["SUBMITTED"] = "SUBMITTED";
})(GroupEnrollmentAction = exports.GroupEnrollmentAction || (exports.GroupEnrollmentAction = {}));
var Status;
(function (Status) {
    Status[Status["OPEN"] = 0] = "OPEN";
    Status[Status["CREATED"] = 1] = "CREATED";
})(Status = exports.Status || (exports.Status = {}));
var Title;
(function (Title) {
    Title[Title["ACCOUNTANT"] = 0] = "ACCOUNTANT";
    Title[Title["ASSISTANT"] = 1] = "ASSISTANT";
    Title[Title["BUSINESS_MANAGER"] = 2] = "BUSINESS_MANAGER";
    Title[Title["CEO"] = 3] = "CEO";
    Title[Title["CFO"] = 4] = "CFO";
    Title[Title["CO_OWNER"] = 5] = "CO_OWNER";
    Title[Title["CONTROLLER"] = 6] = "CONTROLLER";
    Title[Title["COO"] = 7] = "COO";
    Title[Title["HR"] = 8] = "HR";
    Title[Title["MANAGER"] = 9] = "MANAGER";
    Title[Title["OFFICE_MANAGER"] = 10] = "OFFICE_MANAGER";
    Title[Title["OTHER"] = 11] = "OTHER";
    Title[Title["OWNER"] = 12] = "OWNER";
    Title[Title["PARTNER"] = 13] = "PARTNER";
    Title[Title["PRESIDENT"] = 14] = "PRESIDENT";
    Title[Title["SECRETARY"] = 15] = "SECRETARY";
    Title[Title["SUPERVISOR"] = 16] = "SUPERVISOR";
    Title[Title["TREASURER"] = 17] = "TREASURER";
    Title[Title["USER"] = 18] = "USER";
    Title[Title["VP"] = 19] = "VP";
})(Title = exports.Title || (exports.Title = {}));
var Period;
(function (Period) {
    Period[Period["DAY"] = 0] = "DAY";
    Period[Period["WEEK"] = 1] = "WEEK";
    Period[Period["MONTH"] = 2] = "MONTH";
    Period[Period["QUARTER"] = 3] = "QUARTER";
    Period[Period["BIANNUAL"] = 4] = "BIANNUAL";
    Period[Period["ANNUAL"] = 5] = "ANNUAL";
    Period[Period["PAY_PERIOD"] = 6] = "PAY_PERIOD";
})(Period = exports.Period || (exports.Period = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType[PaymentMethodType["CREDIT_CARD"] = 0] = "CREDIT_CARD";
    PaymentMethodType[PaymentMethodType["BANK_DRAFT"] = 1] = "BANK_DRAFT";
    PaymentMethodType[PaymentMethodType["PREMIUM_BILLING"] = 2] = "PREMIUM_BILLING";
    PaymentMethodType[PaymentMethodType["CHECK"] = 3] = "CHECK";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var BillingProviderType;
(function (BillingProviderType) {
    BillingProviderType[BillingProviderType["SYSTEM_I"] = 0] = "SYSTEM_I";
})(BillingProviderType = exports.BillingProviderType || (exports.BillingProviderType = {}));
var Source;
(function (Source) {
    Source[Source["LSWork"] = 0] = "LSWork";
})(Source = exports.Source || (exports.Source = {}));
var DependentType;
(function (DependentType) {
    DependentType[DependentType["Spouse"] = 0] = "Spouse";
    DependentType[DependentType["Dependent"] = 1] = "Dependent";
})(DependentType = exports.DependentType || (exports.DependentType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://group-enrollments.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title GroupEnrollments API
 * @version v1
 * @baseUrl https://group-enrollments.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsGetGroupEnrollmentsByIdentityId
             * @request GET:/v1/identities/{identityId}/groupEnrollments
             * @secure
             */
            groupEnrollmentsGetGroupEnrollmentsByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsCreateGroupEnrollment
             * @request POST:/v1/identities/{identityId}/groupEnrollments
             * @secure
             */
            groupEnrollmentsCreateGroupEnrollment: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsGetGroupEnrollmentById
             * @request GET:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}
             * @secure
             */
            groupEnrollmentsGetGroupEnrollmentById: (enrollmentId, identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollment
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollment: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentOffers
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeOffers
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentOffers: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeOffers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentDependents
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeDependents
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentDependents: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeDependents`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsSubmitGroupEnrollment
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/submit
             * @secure
             */
            groupEnrollmentsSubmitGroupEnrollment: (identityId, enrollmentId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/submit`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentAssociateInfo
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeAssociateInfo
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentAssociateInfo: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeAssociateInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentIdentity
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/changeIdentity
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentIdentity: (enrollmentId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/changeIdentity`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags GroupEnrollments
             * @name GroupEnrollmentsUpdateGroupEnrollmentBusiness
             * @request POST:/v1/identities/{identityId}/groupEnrollments/{enrollmentId}/offers/{offerId}/changeBusinessInfo
             * @secure
             */
            groupEnrollmentsUpdateGroupEnrollmentBusiness: (enrollmentId, offerId, identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/groupEnrollments/${enrollmentId}/offers/${offerId}/changeBusinessInfo`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=group-enrollments.js.map